module.exports = __webpack_public_path__ + "images/yunnan_banner03.jpg?f3c9042aa681e780eba6a6bd4f5c40f4";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/yunnan_banner03.jpg
// module id = 213
// module chunks = 1